// extracted by mini-css-extract-plugin
export default {"containerBody":"Body_containerBody__AfP8S","preloaderWrapper":"Body_preloaderWrapper__Apmt1"};